module.exports = __webpack_public_path__ + "static/img/16areaA_6.12183d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/16areaA_6.png
// module id = 1028
// module chunks = 1